import { gql, TypedDocumentNode } from '@common/hooks';
import {
  DeleteHourBlockMutationCgResponse,
  DeleteHourBlockMutationVariables,
} from '@common/graphql/schema';
import { ReviewWorkerTimesheet } from '@timekeeping/graphql';

export const DeleteHourBlock: TypedDocumentNode<
  DeleteHourBlockMutationCgResponse,
  DeleteHourBlockMutationVariables
> = gql`
  mutation DeleteHourBlock($id: ID!) {
    result: worksTimekeepingDeleteHourBlock(id: $id) {
      workerTimesheet {
        ...ReviewWorkerTimesheet
      }
    }
  }
  ${ReviewWorkerTimesheet}
`;
